import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Fade } from '../Fade';
import { Icon } from '../Icon';
import styles from './Input.css';

const cx = classnames.bind(styles);

function Input({
    value,
    placeholder,
    errorText,
    defaultValue,
    name,
    type,
    inputProps,
    className,
    inputClassName,
    alertClassName,
    label,
    onChange,
    onBlur,
    disabled,
    onKeyDown,
    hideErrorMessage
}) {
    const inputRef = useRef();

    const handleChange = useCallback(e => {
        if (onChange) {
            onChange(name, e.target.value);
        }
    }, [onChange, name]);

    const handleBlur = e => {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };

    const renderInput = () => {
        const inputClasses = cx({
            input: true,
            error: Boolean(errorText),
            withIndent: Boolean(errorText),
            [inputClassName]: Boolean(inputClassName)
        });

        return (
            <input
                className    = {inputClasses}
                defaultValue = {defaultValue}
                value        = {value}
                name         = {name}
                id           = {name}
                type         = {type || 'text'}
                placeholder  = {placeholder}
                onChange     = {handleChange}
                onBlur       = {handleBlur}
                onKeyDown    = {onKeyDown}
                autoComplete = 'off'
                disabled     = {disabled}
                ref          = {inputRef}
                data-1p-ignore
                {...inputProps}
            />
        );
    };

    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            {Boolean(label) && (
                <label htmlFor={name} className={styles.label}>
                    {label}
                </label>
            )}
            <div className={styles.container}>
                {renderInput()}
                {Boolean(errorText) && (
                    <Icon className={styles.icon} name='alertTriangle' />
                )}
            </div>
            {Boolean(errorText) && !hideErrorMessage && (
                <Fade triggerOnce duration={300}>
                    <p className={cx('alert', { [alertClassName]: Boolean(alertClassName) })}>{errorText}</p>
                </Fade>
            )}
        </div>
    );
}

Input.propTypes = {
    type: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    errorText: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    alertClassName: PropTypes.string,
    inputProps: PropTypes.object,
    hideErrorMessage: PropTypes.bool
};

export {
    Input
};
